import {
  GetAllReports200Item as ReportListItem,
  type GetAllReports200Item,
  type GetAllReportsParams,
  type GetAllReports200ItemStatus,
  type GetAllReports200ItemPriority,
  type GetAllReports200ItemTargetType,
  type GetAllReports200ItemReason,
  type GetReportById200,
} from '@edusense/report-client';

export type ReportStatus = GetAllReports200ItemStatus;
export type ReportPriority = GetAllReports200ItemPriority;
export type ReportTargetType = GetAllReports200ItemTargetType;
export type ReportReason = GetAllReports200ItemReason;

export type Report = GetAllReports200Item;
export type ReportDetail = GetReportById200;

export type ReportFilters = Pick<GetAllReportsParams, 'status' | 'priority' | 'targetType' | 'reason'>;

export const REPORT_STATUS_VALUES: ReportStatus[] = [
  'PENDING',
  'REVIEWING',
  'RESOLVED',
  'REJECTED',
  'APPEALED',
  'CLOSED',
];

export const REPORT_PRIORITY_VALUES: ReportPriority[] = [
  'LOW',
  'NORMAL',
  'HIGH',
  'URGENT',
  'CRITICAL',
];

export const REPORT_TARGET_TYPE_VALUES: ReportTargetType[] = [
  'COURSE',
  'LECTURE',
  'COMMENT',
  'USER',
  'POST',
  'TWEET',
  'ROADMAP',
  'PROJECT',
  'QUESTION',
  'ANSWER',
  'REVIEW',
  'DISCUSSION',
];

export const REPORT_REASON_VALUES: ReportReason[] = [
  'SPAM',
  'INAPPROPRIATE_CONTENT',
  'HARASSMENT',
  'COPYRIGHT_VIOLATION',
  'FALSE_INFORMATION',
  'PRIVACY_VIOLATION',
  'ADULT_CONTENT',
  'VIOLENCE',
  'ILLEGAL_ACTIVITY',
  'IMPERSONATION',
  'SCAM',
  'SELF_HARM',
  'TERRORISM',
  'OTHER',
];

export const REPORT_STATUS_LABELS: Record<ReportStatus, string> = {
  PENDING: '접수됨',
  REVIEWING: '검토 중',
  RESOLVED: '처리 완료',
  REJECTED: '기각됨',
  APPEALED: '항소됨',
  CLOSED: '종료됨',
};

export const REPORT_STATUS_COLOR_MAP: Record<ReportStatus, 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning'> = {
  PENDING: 'warning',
  REVIEWING: 'default',
  RESOLVED: 'success',
  REJECTED: 'destructive',
  APPEALED: 'secondary',
  CLOSED: 'outline',
};

export const REPORT_PRIORITY_LABELS: Record<ReportPriority, string> = {
  LOW: '낮음',
  NORMAL: '보통',
  HIGH: '높음',
  URGENT: '긴급',
  CRITICAL: '심각',
};

export const REPORT_PRIORITY_COLOR_MAP: Record<ReportPriority, 'default' | 'secondary' | 'destructive' | 'outline' | 'success' | 'warning'> = {
  LOW: 'outline',
  NORMAL: 'default',
  HIGH: 'warning',
  URGENT: 'destructive',
  CRITICAL: 'destructive',
};

export const REPORT_TARGET_TYPE_LABELS: Record<ReportTargetType, string> = {
  COURSE: '강의',
  LECTURE: '강의 영상',
  COMMENT: '댓글',
  USER: '사용자',
  POST: '게시글',
  TWEET: '트윗',
  ROADMAP: '로드맵',
  PROJECT: '프로젝트',
  QUESTION: 'Q&A 질문',
  ANSWER: 'Q&A 답변',
  REVIEW: '리뷰',
  DISCUSSION: '토론',
};

export const REPORT_REASON_LABELS: Record<ReportReason, string> = {
  SPAM: '스팸',
  INAPPROPRIATE_CONTENT: '부적절한 내용',
  HARASSMENT: '괴롭힘/혐오',
  COPYRIGHT_VIOLATION: '저작권 침해',
  FALSE_INFORMATION: '허위 정보',
  PRIVACY_VIOLATION: '개인정보 침해',
  ADULT_CONTENT: '성인물',
  VIOLENCE: '폭력성',
  ILLEGAL_ACTIVITY: '불법 활동',
  IMPERSONATION: '사칭',
  SCAM: '사기',
  SELF_HARM: '자해/자살',
  TERRORISM: '테러/극단주의',
  OTHER: '기타',
};

export const formatKoreanDateTime = (value: string | null | undefined): string => {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleString('ko-KR');
  } catch (error) {
    console.error('잘못된 날짜 포맷:', value, error);
    return value;
  }
};

export const formatKoreanDate = (value: string | null | undefined): string => {
  if (!value) return '-';
  try {
    return new Date(value).toLocaleDateString('ko-KR');
  } catch (error) {
    console.error('잘못된 날짜 포맷:', value, error);
    return value;
  }
};

export type { ReportListItem };
